import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { paths } from '../../../../shared/configs/routing';

const AccessGate = ({ children }) => {
  const { state } = useLocation();

  if (!state?.from?.values) {
    return <Redirect to={state?.from?.location || paths.main} />;
  }

  return children;
};

export default AccessGate;
